import { render, staticRenderFns } from "./GroupSearch.vue?vue&type=template&id=1b229a86&scoped=true&"
import script from "./GroupSearch.vue?vue&type=script&lang=ts&"
export * from "./GroupSearch.vue?vue&type=script&lang=ts&"
import style0 from "./GroupSearch.vue?vue&type=style&index=0&id=1b229a86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b229a86",
  null
  
)

export default component.exports